<template>
    <div v-if="items.length === 0">
        {{noInitialsText}}
    </div>
    <div v-else>
        <initials v-for="item in items" :key="item" :fullName="item"/>
    </div>
</template>

<script>
    import Initials from './Initials'
    export default {
        name: 'InitialsList',
        props: {
            items: Array,
            noInitialsText: {
                type: String,
                default: '-'
            }
        },
        components: {
            Initials
        }
    }
</script>

<style scoped>

</style>